import React from 'react';
import { CCard, CCardBody } from '@coreui/react';
import { CChart } from '@coreui/react-chartjs';

/**
 * Month-to-date widget showing revenue and growth
 */
const MonthToDateWidget = () => {
  return (
    <CCard className="month-to-date-widget">
      <CCardBody>
        <div className="widget-content">
          <div className="metric-info">
            <div className="metric-label">Month-to-date</div>
            <div className="metric-value-container">
              <span className="metric-value">$13.3k</span>
              <span className="metric-change positive">+7.5%</span>
            </div>
          </div>
          
          <div className="chart-container">
            {/* Background Chart */}
            <div className="chart-layer background">
              <CChart
                type="line"
                height={55}
                data={{
                  labels: Array(12).fill(''),
                  datasets: [{
                    label: 'Previous Month',
                    backgroundColor: 'rgba(35, 132, 2, 0.25)',
                    borderColor: 'rgba(35, 132, 2, 0.25)',
                    pointBackgroundColor: 'transparent',
                    pointBorderColor: 'transparent',
                    tension: 0.4,
                    fill: true,
                    data: [0, 10, 25, 20, 15, 5, 30, 40, 55, 40, 45, 55],
                  }]
                }}
                options={{
                  maintainAspectRatio: false,
                  plugins: { legend: { display: false } },
                  scales: {
                    x: { display: false, grid: { display: false } },
                    y: { display: false, grid: { display: false } }
                  },
                  elements: {
                    line: { borderWidth: 1 },
                    point: { radius: 0 }
                  }
                }}
              />
            </div>
            
            {/* Foreground Chart */}
            <div className="chart-layer foreground">
              <CChart
                type="line"
                height={55}
                data={{
                  labels: Array(12).fill(''),
                  datasets: [{
                    label: 'Current Month',
                    backgroundColor: 'transparent',
                    borderColor: 'var(--cui-primary)',
                    pointBackgroundColor: 'transparent',
                    pointBorderColor: 'transparent',
                    tension: 0.4,
                    data: [5, 10, 15, 0, 20, 25, 50, 40, 35, 30, 45, 55],
                  }]
                }}
                options={{
                  maintainAspectRatio: false,
                  plugins: { legend: { display: false } },
                  scales: {
                    x: { display: false, grid: { display: false } },
                    y: { display: false, grid: { display: false } }
                  },
                  elements: {
                    line: { borderWidth: 2 },
                    point: { radius: 0 }
                  }
                }}
              />
            </div>
          </div>
        </div>
      </CCardBody>
    </CCard>
  );
};

export default MonthToDateWidget; 